import './App.css';
import Main from './Components/main';

function App() {
  return (
    <div>
      <Main />

    </div>
  );
}

export default App;
